import { getPlan, getPrice, prepareDietForPayment } from './stripe';
import { fetcher } from './fetcher';

export const initStripePaymentButton = (stripePayButtonVars, uuid, reinitPayment = false) => {
  const stripe = Stripe(stripePayButtonVars.token);

  let usingMethod = '';

  const paymentRequest = stripe.paymentRequest({
    country: 'US',
    currency: stripePayButtonVars.domainPayment.currency.name.toLowerCase(),
    total: {
      label: stripePayButtonVars.paymentLabel,
      amount: Number((stripePayButtonVars.priceForDisplayInPaymentForm * 100).toFixed()),
    },
    requestPayerName: false,
    requestPayerEmail: false,
    requestShipping: false,
  });

  paymentRequest.canMakePayment().then(result => {
    if (result) {
      const buttonDiv = document.querySelector('.stripe-pay-button');

      if (reinitPayment == false) {
        const svg = buttonDiv.find('svg');

        usingMethod = result.applePay ? 'Apple' : 'Google';

        svg.addClass('icon-' + usingMethod.toLowerCase() + '-pay');
        svg.find('use').attr('xlink:href', '/img/sprite.svg#icon-' + usingMethod.toLowerCase() + '-pay');
      }
      buttonDiv.show();
    }
  });

  paymentRequest.on('paymentmethod', ev => {
    const paymentMethod = ev.paymentMethod.id;

    prepareDietForPayment('stripe-pay-button', false);

    const plan = getPlan();
    const price = getPrice();

    let data = {
      uuid: uuid,
      provider: 'stripe-pay-button',
      usingMethod: 'Stripe' + usingMethod + 'Button',
      paymentMethod: paymentMethod,
    };

    if (plan && price) {
      data.plan = plan;
      data.price = price;
    }

    const isPaidPart = stripePayButtonVars.paymentFlow === 'subscription' ? 'subscription/is-paid' : 'is-paid',
      systemType = window.backEndVars.systemType;
    const checkUrl = new Url().build(systemType, uuid, isPaidPart);
    fetcher
      .post(stripePayButtonVars.url, data, { Accept: 'application/json' })
      .then(result => {
        data = {};
        data.type = result.type;
        payments.checkPaymentStatusAndRedirect('stripe', checkUrl, data, ev);
      })
      .catch(error => {
        if (error.status === 455) {
          new Url().redirectTo('meal-plan-error');
        } else if (error.status === 404) {
          new Url().redirectTo('/');
        } else {
          ev.complete('fail');
        }
      });
  });
};
